import { formatSuggestionForSubmission } from '../../methods/format-suggestion'
import { validateAndFixUrl } from '@/utils/urlUtils'

/**
 * API'ye göndermek için öneri verilerini formatlar ve doğrular
 * @param {Object} suggestionData - Ham öneri verileri
 * @returns {Object} Formatlanmış öneri verileri
 */
export const formatData = (suggestionData) => {
  // API'ye göndermek için verileri formatla
  const formattedData = formatSuggestionForSubmission(suggestionData)

  // İçerik URL'lerinin protokolünü düzeltme (http/https eksikse ekleme)
  if (formattedData.contentType === 'IMAGE' && formattedData.currentImageUrl) {
    formattedData.currentImageUrl = validateAndFixUrl(formattedData.currentImageUrl)
  }

  return formattedData
}